import Swiper, { Navigation, Pagination } from 'swiper';

import { loop } from '/src/scripts/utils/common';

loop('.image-carousel', (box) => {
  const show = box.querySelector('.image-carousel__swiper');

  new Swiper(show, {
    loop: true,
    grabCursor: true,
    spaceBetween: 40,
    modules: [Navigation, Pagination],
    navigation: {
      prevEl: box.querySelector('.image-carousel__arrow_prev'),
      nextEl: box.querySelector('.image-carousel__arrow_next'),
    },
    pagination: {
      el: box.querySelector('.image-carousel__pages'),
      clickable: true,
    },
  });
});
